// Every string on the Price Fetch page, so wording still open with the feature owner
// (DP-25 §3 Q1) changes in one file. The wording follows the prototype, including "ML model"
// (owner decision, 2026-10-30; docs/domain.md still says "pricing model").

import { formatTime } from './fetch-time'
import { shortNames, type Weekday, WEEKDAYS } from './weekdays'

export const PAGE_TITLE = 'Price Fetch'

export const intro = (engineName: string) =>
  `How often ${engineName} fetches prices from the ML model. This clock always pulls new recommendations. Hours with Autopilot on in Guardrails (a season timeframe, or default limits) auto-approve in-band and write on this schedule. Hours with Autopilot off wait on Review & approve.`

export const LOADING_ENGINES = 'Loading engines…'
export const CHOOSE_ENGINE =
  'Choose a dynamic engine in the header to see its Price Fetch settings.'
export const NO_PERMISSION = "You don't have permission to manage Price Fetch settings."

export const LOADING_SETTINGS = 'Loading Price Fetch settings…'
export const LOAD_FAILED = 'The Price Fetch settings could not be loaded.'
export const RETRY = 'Retry'

export const CARD_HEADING = 'How Often To Fetch'
export const QUESTION = 'How often should we fetch prices from the ML model?'
export const SCHEDULES = {
  hourly: {
    label: 'Hourly',
    help: 'Fetch prices from the ML model every hour. Timeframes with Autopilot on write in-band hours on that tick. No extra settings.',
  },
  daily: {
    label: 'Daily',
    help: 'Fetch once a day at the time and on the days you select. Autopilot timeframes write in-band hours on that run.',
  },
} as const

export const DAYS_LABEL = 'Days of the week'
export const DAYS_HELP =
  'Default is all seven days. Turn days off to skip, for example weekends. At least one day must stay on.'
export const DAYS_REQUIRED = 'At least one day must stay on.'

export const TIME_LABEL = 'Fetch at'
export const MERIDIEM_LABEL = 'AM or PM'
// Until the API returns the course's timezone (after DP-19), the label says only that the
// time is the course's own (DP-25 §6 #1).
export const LOCAL_TIME = 'course local time'
export const TIME_HELP = 'Default is 6:00 AM. This is when the daily fetch runs on selected days.'
export const TIME_INVALID = 'Enter a time like 6:00'

const SCHEDULE_TAIL =
  'Turn Autopilot on or off per timeframe (and for default hours) on Guardrails. Pause still wins.'

/** "Current schedule: daily at 6:00 AM on Mon, Fri." The days only when not all seven are on. */
export function currentSchedule(schedule: 'hourly' | 'daily', days: Weekday[], time: string) {
  if (schedule === 'hourly') return `Current schedule: hourly. ${SCHEDULE_TAIL}`
  const on = days.length === WEEKDAYS.length ? '' : ` on ${shortNames(days).join(', ')}`
  return `Current schedule: daily at ${formatTime(time)}${on}. ${SCHEDULE_TAIL}`
}

export const SAVING = 'Saving…'
export const SAVED = 'Saved'
export const SAVE_FAILED = 'The Price Fetch settings could not be saved.'
export const NOT_SAVED = 'Not saved. Check the highlighted field.'

export const LEAVE_TITLE = 'Leave without saving?'
export const LEAVE_MESSAGE = 'A change on this page is not saved yet. If you leave now, it is lost.'
export const LEAVE = 'Leave without saving'
export const STAY = 'Stay on page'
